import createReactComponent from '../createReactComponent';
export default createReactComponent('square-asterisk', 'IconSquareAsterisk', [
  [
    'path',
    {
      d: 'M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z',
      key: 'svg-0',
    },
  ],
  ['path', { d: 'M12 8.5v7', key: 'svg-1' }],
  ['path', { d: 'M9 10l6 4', key: 'svg-2' }],
  ['path', { d: 'M9 14l6 -4', key: 'svg-3' }],
]);
